module.exports = __webpack_public_path__ + "img/webBg.2931d313.jpg";